const variantSelect = document.querySelector(".product__content .product__selectors .radio__fieldset");

variantSelect.addEventListener("change", async (event) => {
  console.log("variant changed"); 
  //console.log(event.dataset.variant.sku);

  const variantSelectedSku = event.dataset.variant.sku;
  const variantSku = document.querySelector('.product__sku span');

  variantSku.textContent = variantSelectedSku;
});